<template>
  <question v-on="$listeners" v-bind="$attrs" :question="question" :operates="operates" :type="isSpecial ? 'view' : 'edit'" />
</template>

<script>
import Question from '@/question/components/Question'
import SampleCompanyMixin from '@/views/other-pages/sample-company/sample-company-mixin'
import { questionType } from '@dygc/question'

export default {
  name: 'SampleQuestion',
  props: {
    question: {
      type: Object,
      default: () => ({})
    }
  },
  components: { Question },
  mixins: [SampleCompanyMixin],
  computed: {
    isSpecial() {
      const type = this.question.question_type
      return (
        (this.isPhone && [questionType.CELLPHONE,questionType.NAME].includes(type)) ||
        (this.isEmail && type === questionType.EMAIL) ||
        (this.isAddress && type === questionType.POINT_POSITION)
      )
    },
    operates() {
      const operates = ['move']
      if (this.isSpecial) {
        return operates
      }
      operates.push('remove')
      return operates
    }
  },
  created() {
    if (this.isSpecial) {
      this.question.disabledRemove = true
    }
  }
}
</script>

<style scoped></style>
